document.addEventListener('DOMContentLoaded', function () {
    // GN: any "Chat with us" link (footer menus, mega menu, anywhere) opens
    // the Shopify Inbox widget. Delegated so it also works for links rendered
    // later, and matched on the link text because the menu item is a "#" link.
    // (The old version only looked for Ella's .list-menu__item--link markup,
    // which the custom gn-footer no longer uses.)
    window.gnOpenChat = function () {
        // Shopify Inbox has shipped several widget shapes: the current one is a
        // <shopify-chat> element whose launcher button has class "activator";
        // older ones were #ShopifyChat (.chat-toggle) and <inbox-online-store-chat>.
        // A page can hold more than one widget element (e.g. a data-only one),
        // so check every candidate for a launcher button.
        var hosts = document.querySelectorAll("shopify-chat, #ShopifyChat, inbox-online-store-chat");
        var openAlready = false;
        for (var i = 0; i < hosts.length; i++) {
            var sr = hosts[i].shadowRoot;
            var toggle = sr && (sr.querySelector("button.activator") || sr.querySelector(".chat-toggle"));
            if (toggle) { toggle.click(); return true; }
            // rendered but no launcher = the chat window is already open
            if (sr && sr.querySelector("*")) openAlready = true;
        }
        return openAlready;
    };
    // The widget loads a few seconds after the page. A click before that is
    // queued: keep trying for up to ~8s, then give up (onFail, if given).
    window.gnOpenChatWhenReady = function (onFail) {
        if (window.gnOpenChat()) return;
        var tries = 0;
        var t = setInterval(function () {
            tries++;
            if (window.gnOpenChat()) { clearInterval(t); }
            else if (tries > 32) { clearInterval(t); if (onFail) onFail(); }
        }, 250);
    };
    document.addEventListener("click", function (e) {
        var a = e.target.closest && e.target.closest("a, button");
        if (!a || a.hasAttribute("data-gnct-chat")) return;
        var isChat = a.hasAttribute("data-gn-open-chat") || /^\s*chat with us\s*$/i.test(a.textContent || "");
        if (!isChat) return;
        e.preventDefault();
        window.gnOpenChatWhenReady();
    });

    // GN: vertically centre the chat bubble against the slim footer bottom
    // bar (~68px tall). The widget loads asynchronously and lives in a
    // shadow root, so poll briefly and set the offset inline.
    var gnChatTries = 0;
    var gnChatTimer = setInterval(function () {
        gnChatTries++;
        var chat = document.querySelector('#ShopifyChat');
        var toggle = chat && chat.shadowRoot && chat.shadowRoot.querySelector('.chat-toggle');
        if (toggle) {
            // centre the bubble vertically within the footer bottom bar (the
            // toggle box is taller than the visible bubble, so a small fixed
            // offset lands the visible circle on the bar's midline)
            toggle.style.bottom = '20px';
            toggle.style.right = '20px';
            var nudge = chat.shadowRoot.querySelector('.activator-nudge');
            if (nudge) nudge.style.margin = '-10px';
            clearInterval(gnChatTimer);
        } else if (gnChatTries > 50) {
            clearInterval(gnChatTimer);
        }
    }, 300);
});